import { render, staticRenderFns } from "./drug.vue?vue&type=template&id=40d08f13&scoped=true&"
import script from "./drug.vue?vue&type=script&lang=js&"
export * from "./drug.vue?vue&type=script&lang=js&"
import style0 from "./drug.vue?vue&type=style&index=0&id=40d08f13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d08f13",
  null
  
)

export default component.exports